import { Container, Grid, Typography } from '@mui/material';
import { SERVICE_ID_FOR_JOB_DETAILS } from '@/constants';
import { getSegmentationJobDetails_getSEOSegmentationJobDetails_seoSegmentationJob_jobPreferences as JobPreferences } from '@/__generated__/getSegmentationJobDetails';
import HousekeepingJobPreferences from './HousekeepingJobPreferences';
import TutoringJobPreferences from './TutoringJobPreferences';

interface JobAdditionalDetailsProps {
  jobPreferences: JobPreferences;
  serviceName: string;
}
const JobAdditionalDetails = ({ jobPreferences, serviceName }: JobAdditionalDetailsProps) => {
  const headline = () => {
    return serviceName === SERVICE_ID_FOR_JOB_DETAILS.housekeeping ||
      serviceName === SERVICE_ID_FOR_JOB_DETAILS.tutoring
      ? 'Job details'
      : "Who you'll care for";
  };

  return (
    <Container maxWidth="md" sx={{ pt: 1 }}>
      <Typography variant="h2" mb={2}>
        Additional details
      </Typography>
      <Grid container>
        <Typography variant="h4">{headline()}</Typography>
        <Grid item xs={12} sx={{ mt: 1 }}>
          {jobPreferences.__typename === 'HousekeepingJobPreferences' && (
            <HousekeepingJobPreferences jobPreferences={jobPreferences} />
          )}
          {jobPreferences.__typename === 'TutoringJobPreferences' && (
            <TutoringJobPreferences jobPreferences={jobPreferences} />
          )}
          {(jobPreferences.__typename === 'ChildCareJobPreferences' ||
            jobPreferences.__typename === 'PetCareJobPreferences') && (
            <Typography variant="body2">{jobPreferences.additionalDetails.join(', ')}</Typography>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default JobAdditionalDetails;
